import { render, staticRenderFns } from "./CreateTicketModal.vue?vue&type=template&id=98fd2ca2&scoped=true"
import script from "./CreateTicketModal.vue?vue&type=script&lang=js"
export * from "./CreateTicketModal.vue?vue&type=script&lang=js"
import style0 from "./CreateTicketModal.vue?vue&type=style&index=0&id=98fd2ca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fd2ca2",
  null
  
)

export default component.exports